import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { Addtowatchlistaction, Checkuserwatchlist } from "../../Model/Users";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import {
  withRouter,
  Imgbanner,
  SVGIcons,
  ImgIcons,
  Appsflyer,
  branchIO,
} from "../../Helpers/Common";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import videojs from "video.js";
import BarLoader from "react-spinners/BarLoader";
import Metadata from "../Metadata/Metadata";
import { isMobile } from "react-device-detect";
/*-------------Importing Images --------------*/
var Imgbanners = "";
var SVGIcon = "";
var ImageData = "";

Imgbanner().then((result) => (Imgbanners = result));
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((result) => (SVGIcon = result));

export function Banner(props) {
  const [trailerplayer, settrailerplayer] = useState(false);
  var vidRef = useRef([]);
  const subtitles = [];
  var content;
  const [Addtowatchlist, setAddtowatchlist] = useState(false);
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  const [MainDetailsp, setMainDetailsp] = useState(false);
  const [PlayURLbtn, setPlayURLbtn] = useState(false);
  const [PlayURLbtndata, setPlayURLbtndata] = useState(false);
  const [showmodel, setshowmodel] = useState(false);
  const [player, setPlayer] = useState(false);
  const [playermute, setplayermute] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [handleTimeout]);

  const videoRef = useRef();

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(props.BannerDatas[0]);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  function debounce(func, delay) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(func, delay);
    };
  }

  function handleScroll() {
    var video = vidRef.current["ov" + data.ID];
    if (video) {
      if (window.scrollY > 350) {
        video.pause();
      } else if (window.scrollY === 0) {
        video.play();
      }
    }
  }

  useEffect(() => {
    var Postdata = {
      content_id: props.BannerDatas[0].ID,
    };
    // window.addEventListener("scroll", handleScroll);
    const debouncedHandleScroll = debounce(handleScroll);
    window.addEventListener('scroll', debouncedHandleScroll);

    var Postdata = {
      content_id: props.BannerDatas[0].ID,
      content_type: props.BannerDatas[0].type,
    };

    if (props.BannerDatas[0].isWatchList == true) {
      setAddtowatchlist(true);
    }
  }, []);

  function closePlayer() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
  }

  var LastElement = props.BannerDatas.length;

  var data = props.BannerDatas[0];
  var awards = "";
  var GenereTitle = data.genres.split(",");
  GenereTitle = GenereTitle[0];

  function PlayURL(content_id, content_type) {
    setPlayURLbtn(true);
    // Appsflyer("Promo Banner Watched", {
    //   "Promo Name": props.BannerDatas[0].title,
    //   "Content ID": props.BannerDatas[0].ID,
    // });
    // branchIO("Promo Banner Watched", {
    //   "Promo Name": props.BannerDatas[0].title,
    //   "Content ID": props.BannerDatas[0].ID,
    // });
  }

  function Showmodels() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(true);
  }
  function Closemodel() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(false);
  }
  function addtowatchlist() {
    if (Addtowatchlist == true) {
      var action = "delete";
    } else {
      var action = "add";
    }

    var data = {
      content_id: [props.BannerDatas[0].ID],
      action: action,
    };

    Addtowatchlistaction(data).then((Response) => {
      if (Addtowatchlist == true) {
        setAddtowatchlist(false);

        toast("Removed from Watchlist", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message",
        });
      } else {
        //Add To watchlist
        var data = {
          content_id: [props.BannerDatas[0].ID],
          action: "add",
        };
        setAddtowatchlist(true);
        toast("Added to Watchlist", {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          draggable: true,
          theme: "light",
          className: "toast-message",
        });
      }
    });
  }
  if (data.awards) {
    var awards = (
      <p>
        <img src={SVGIcon["wincup.svg"]} /> Award Winning
      </p>
    );
  }

  if (PlayURLbtn == true && PlayURLbtndata == false) {
    // return <div className="loader"></div>;
    return (
      <div className="loader">
        <BarLoader color="#ff000f" />
      </div>
    );
  }

  if (PlayURLbtn && !PlayURLbtndata) {
  }

  // function hoverV() {
  //   //
  //   var Postdata = {
  //     content_id: data.ID,
  //     session_id: localStorage.getItem("session_id"),
  //     userID: localStorage.getItem("userID")
  //   };

  //   Checkuserwatchlist(Postdata).then((res) => {
  //     var Response = JSON.parse(res.data);
  //     if (Response.iswatched == true) {
  //       setAddtowatchlist(true);
  //     }
  //   });
  //   const hoverPlay = data.promo_url;

  //   const videoJsOptions = {
  //     autoplay: false,
  //     preload: "none",
  //     aspectRatio: "15:15",
  //     height: "auto",
  //     width: "100%",
  //     muted: true,
  //     loop: true,
  //     controls: false,
  //     sources: [
  //       {
  //         src: data.promo_url,
  //         type: "application/x-mpegURL",
  //         withCredentials: false,
  //       },
  //     ],
  //   };
  //   console.log("data.ID -->>", data.ID);
  //   const p = videojs(vidRef.current["ov" + data.ID], videoJsOptions);
  //   const myTimeout = setTimeout(myGreeting, 3000);
  //   function myGreeting() {
  //     p.play();
  //   }
  //   setPlayer(p);
  // }

  function hoverV() {
    const videoElement = vidRef.current["ov" + data.ID];

    // Check if the video element exists
    if (videoElement) {
      const Postdata = {
        content_id: data.ID,
        session_id: localStorage.getItem("session_id"),
        userID: localStorage.getItem("userID")
      };

      // Assuming Checkuserwatchlist returns a promise
      Checkuserwatchlist(Postdata).then((res) => {
        const Response = JSON.parse(res.data);
        if (Response.iswatched) {
          setAddtowatchlist(true);
        }
      });

      const videoJsOptions = {
        autoplay: false,
        preload: "none",
        aspectRatio: "15:15",
        height: "auto",
        width: "100%",
        muted: true,
        loop: true,
        controls: false,
        sources: [
          {
            src: data.promo_url,
            type: "application/x-mpegURL",
            withCredentials: false,
          },
        ],
      };
      // Initialize Video.js only if the video element exists
      const player = videojs(videoElement, videoJsOptions);

      // Play the video after 3 seconds
      const myTimeout = setTimeout(() => {
        player.play();
      }, 3000);
      // Set the player state
      setPlayer(player);
    } else {
      console.error("Video element not found or invalid");
    }
  }

  function toggleMute() {
    var video = vidRef.current["ov" + data.ID];
    video.muted = !video.muted;
    if (playermute) {
      setplayermute(false);
    } else {
      setplayermute(true);
    }
  }
  var GenreAsign;
  if (data.genres_assign.length > 0) {
    var GenreAsign = data.genres_assign[0].name;
  }

  return (
    <>
      {/* <Metadata page="HOME" /> */}
      <div>
        {/* <section> */}
        <div className="banner-overlay dD-none" />
        <div className="banner-overlay-3"></div>
        {/* <div className="banner-overlay-4"></div> */}
        {/* <div className="banner-overlay-5"></div> */}

        {/* {showShimmer ? (
          <img src={ImageData["placeholder1.png"]} alt="shimmer" className="shimmer" style={{ width: "-webkit-fill-available" }} />
        ) : (
          <>
          </>)} */}
        <div className="mainBanner dD-none">
          <div className="mainInBanr bannerImg">
            <Link to={"/" + data.slug}>
              <picture>
                <source
                  // srcSet={data.banner_image.large}
                  srcSet={Imgbanners["main-banner.jpg"]}
                  media="(min-width: 850px)"
                />
                <source
                  srcSet={data.thumbnail_image1.large}
                  // srcSet={Imgbanners["main-banner.jpg"]}
                  media="(min-width: 650px)"
                />
                <source
                  /*srcSet={Imgbanners["main-banner.jpg"]}*/
                  srcSet={data.thumbnail_image2.large}
                  media="(min-width: 300px)"
                />
                <img src={data.thumbnail_image2.large}></img>
              </picture>
            </Link>
          </div>
        </div>
        {/* <div className="bg-video-wrap dD-block">
          <video
            ref={(el) => (vidRef.current["ov" + data.ID] = el)}
            poster={data.mxplayer_landscape_banner.original}
            className="onhover"
            id="mute"
          ></video>
        </div> */}
        {isMobile ? null : (
          <div className="bg-video-wrap dD-block">
            <video
              ref={(el) => (vidRef.current["ov" + data.ID] = el)}
              poster={data.mxplayer_landscape_banner.original}
              className="onhover banner-main-img"
              id="mute"
            ></video>
          </div>
        )}

        {showmodel ? (
          <div className="temp79">
            <div className="temp79-area temp79-area-modal">
              <div className="temp79-item ">
                {/* <a> */}
                <img
                  src={ImageData["close.png"]}
                  alt="closeImg"
                  className="close-modal-icon Closemodel"
                  onClick={() => {
                    Closemodel();
                  }}
                />
                {/* </a> */}
                <img
                  src={SVGIcon["lock.svg"]}
                  alt="Lock"
                  className="lock-img"
                />
                <h5>Become a member to continue watching </h5>
                <div className="c-watching">
                  <button type="submit" id="sendEnquiryBtn" className="btn-red">
                    Continue
                  </button>
                </div>
                <p>Download our App on</p>
                <div className="temp79-img">
                  {" "}
                  <a href="https://itunes.apple.com/in/app/epic-on/id1458102898?mt=8">
                    {" "}
                    <img src={ImageData["app-store.png"]} alt="App Store" />
                  </a>{" "}
                  <a href="https://play.google.com/store/apps/details?id=com.epic.docubay">
                    {" "}
                    <img
                      src={ImageData["google-play-badge.png"]}
                      alt="google-play"
                    />{" "}
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <section className="mb-0 dD-none">
          <div className={"temp11 " + props.clsname}>
            <div className="temp11-head">
              <img
                src={SVGIcon["wave-left.svg"]}
                onClick={() => {
                  showdetailspop();
                }}
              />
              <Link to={"/playcontent/" + data.slug}>
                <img src={SVGIcon["play.svg"]} />
              </Link>
              <div onClick={addtowatchlist} className="bannerpop-modal-toggle">
                {Addtowatchlist ? (
                  <img src={SVGIcon["red-right.svg"]} />
                ) : (
                  <img src={SVGIcon["wave-right.svg"]} />
                )}
              </div>
            </div>
            <div className="temp11-text">
              {/* {showShimmer ? (
                <>
                  <div className="line" />
                  <div className="line1" />
                </>
              ) : (
                <> */}
              {awards}
              <h2>{data.title}</h2>
              <div className="temp11-inn">
                {data.original_tag ?
                  <img src={props.goldenIcon} style={{ width: "24px" }} />
                  :
                  data.premium_tag ?
                    <img src={props.silverIcon} style={{ width: "24px" }} />
                    : null
                }
                <div className="nBay1 nBay2">
                  {data.content_category}&nbsp;
                  {data.age_restriction}
                </div>
                <div className="nBay">{GenreAsign}</div>
              </div>
              {/* </>
              )} */}
            </div>

          </div>
        </section>
        <div className="temp81 dD-block">
          <div className="temp81Inner">
            <div className="temp81-head" onLoad={() => hoverV()}>
              <p className="popup-animation">
                {data.new ? (
                  <>
                    New
                    <span className="dot" />
                    &nbsp;
                  </>
                ) : (
                  ""
                )}
                {data.release_date}
                &nbsp;
                {data.duration / 60 == 0 ? "" : <><span className="dot" /> {data.duration / 60} Mins</>}
                {data.video_4k ? (
                  <span className="hd-mainDetails">4K</span>
                ) : data.video_hd ? (
                  <span className="hd-mainDetails">HD</span>
                ) : null}
              </p>
              <Link to={"/" + data.slug}>
                <img
                  src={data.title_image_newui.original}
                  className="banner-logo"
                />
              </Link>
              <div className="temp81-headInn popup-animation">
                <div className="banner-premium-icon">
                  {data.premium && !data.original_tag ? (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.7rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  ) : null}
                  {data.premium && data.original_tag ? (
                    <img
                      src={props.goldenOriginalIcon}
                      style={{
                        width: "9rem",
                        marginRight: "6px",
                        marginBottom: "2px",
                      }}
                    />
                  ) : null}
                </div>
                <div className="hd1">
                  {data.content_category}&nbsp;
                  {data.age_restriction}
                </div>
                <div className="hd2">{GenreAsign}</div>
                <div className="hd2">{data.keywords.split(',')[0]}</div>
              </div>
              <h3>{data.short_description}</h3>
              <div className="temp81-btn popup-animation">
                <Link to={"/playcontent/" + data.slug}>
                  <img
                    src={ImageData["Play_Button_02.png"]}
                    className="btn1"
                    onClick={() => {
                      PlayURL(data.ID, data.type);
                    }}
                  />
                  <div className="play-text">Watch</div>
                </Link>

                {/*<div className="play-text" onClick={() => { PlayURL(data.ID, data.type) }}>Watch</div>*/}
                {/* <img src={ImageData["plus-math--v1.png"]} className="btn2" /> */}
                <div onClick={addtowatchlist}>
                  {Addtowatchlist ? (
                    <img src={ImageData["Right-Icon.png"]} className="btn2" />
                  ) : (
                    <img src={ImageData["Ad-Watchlist.png"]} className="btn2" />
                  )}
                </div>
                <div className="mute-button" onClick={toggleMute}>
                  {playermute ? (
                    <img src={ImageData["audio-unmute.png"]} className="btn2" />
                  ) : (
                    <img src={ImageData["audio-mute.png"]} className="btn2" />
                  )}
                </div>
              </div>
              {/* <div className="mute-button" onClick={toggleMute}>
                {playermute ? (<img src={ImageData["audio-unmute.png"]} className="btn2" />) : (<img src={ImageData["audio-mute.png"]} className="btn2" />)}
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Banner;
